module.exports = "/packs/images/homepage/facilities/venues_mobile~f93c70d4059c0b2aabf08c4e296543ac.jpg";